import { UrlProvider } from "lib/UrlProvider";
import { ILoginProvider } from "./ILoginProvider";
import { LoginResponse } from "../Model";
import { Pipeline, Request } from "lib/HTTP";
import { GoogleLoginResponseOnline, SocialLogin } from "@capgo/capacitor-social-login";
import { DOM } from "lib/DOM";


export class GoogleNativeLoginProvider implements ILoginProvider {
    static async init() {
        await DOM.ready();

        await SocialLogin.initialize({
            google: {
                webClientId: '1019953375418-013mvp0e8vbq48ee6itps37dupkrea2m.apps.googleusercontent.com', // WebClientId !!!!
                mode: 'online' // No we must be online
            },
        });
    }
    getName = () => "GoogleNativeLoginProvider";

    async login(): Promise<LoginResponse> {
        try {

            const googleResponse = await SocialLogin.login({
                provider: 'google',
                options: {
                    scopes: ['profile', 'email']
                },
            });

            const googleLoginResponseOnline = googleResponse.result as GoogleLoginResponseOnline;
            const credentials = { token: googleLoginResponseOnline.accessToken.token };
            const response = await new Pipeline().fetch(`${new UrlProvider().root}/api/external-login/google`, new Request().setJSON(credentials));

           
            if (!response.ok)
                return { status: "failure" };

            const loginResponse = await response.json() as LoginResponse;
            return loginResponse;

        } catch (error) {
            return { status: "failure" };
        }
    }
}

try {
    GoogleNativeLoginProvider.init();
} catch (error) {
    console.log("Unable to initialize google login provider", error);
}